import {throttle} from "./throttle";

export function globalAnimation() {
    let animatedParents = $(".has-animate-children");
    let win = $(window);

    animatedParents.each(function () {
        $(this).find("> *").addClass("has-animate");
    });

    let animatedBlocks = $(".has-animate");
    let numbersBlocks = animatedBlocks.length;

    function init(obj) {
        obj.each(function () {
            let cur = $(this);
            let offset = parseInt(cur.offset().top);
            let wTop = win.scrollTop();
            let h = parseInt(offset + cur.outerHeight());

            if ((h < wTop) || (offset > (wTop + win.height()))) {

            } else {
                cur.addClass("animated");

                if (obj.filter(".animated").length == numbersBlocks) {
                    win.unbind("scroll.Animation");
                }
            }
        });
    }

    win.on("load", function () {
        init(animatedBlocks);
    }).on("scroll.Animation", throttle(function () {
        init(animatedBlocks);
    }, 300));

    return {
        init: function () {
            init(animatedBlocks);
        }
    };
}


// WEBPACK FOOTER //
// ./assets/js/modules/globalAnimation.js